<template>
    <div class="nav list">
        <template v-if="!isTwo">
            <div class="item"
                 :class="{active:routerName===item.routerName}"
                 v-for="item in navList"
                 @click="jump(item.columnText)"
            >
                {{item}}
            </div>
        </template>
        <template v-else>
            <div class="item"
                 :class="{active:routerName===item.routerName}"
                 v-for="item in navList2"
                 @click="jump(item.routerName)"
            >
                {{item}}
            </div>
        </template>
    </div>
</template>

<script>
    import axios from "axios"
    export default {
        name: "Saas-nav",
        data() {
            return {
                navList: [],
                navList2: [
                    {name: 'MT供应链金融平台', routerName: 'tiezhengwang'},
                    {name: 'MT电子证据存证平台', routerName: 'hncrpt'},
                    // {name: 'MT区块链公共服务平台', routerName: 'mgr'},
                    {name: 'QuantStone', routerName: 'rock'},
                ],
                navBannerInfo: {
                    mtevidence: {
                        title: "兆存",
                        text: "MT区块链数据存证平台",
                        url: "7",
                        btnName: "立即登录",
                        url1: 'http://profile.trilliontrust.com/'

                    },
                    mtfin: {
                        title: "兆票",
                        text: "MT区块链供应链金融平台",
                        url: "1",
                        btnName: "立即体验",
                        url1: "http://mtf.trilliontrust.com/"
                    },
                    mtassets: {
                        title: "兆权",
                        text: "MT区块链资产确权登记平台",
                        url: "2",
                        btnName: "联系我们",
                        url1: ''
                    },
                    mtcredit: {
                        title: "兆信",
                        text: "MT区块链企业征信平台",
                        url: "3",
                        btnName: "联系我们",
                        url1: ''
                    },
                    mttep: {
                        title: "兆训",
                        text: "MT区块链教学实训平台",
                        url: "4",
                        btnName: "联系我们",
                        url1: ''
                    },
                    mtdtp: {
                        title: "兆易",
                        text: "MT区块链数据交易平台",
                        url: "5",
                        btnName: "联系我们",
                        url1: ''
                    },
                    mttraceability: {
                        title: "兆源",
                        text: "MT区块链商品溯源平台",
                        url: "6",
                        btnName: "联系我们",
                        url1: ''
                    },
                    mtdas: {
                        title: "兆融",
                        text: "MT区块链数据价值融通服务平台",
                        url: "6",
                        btnName: "立即登录",
                        url1: 'http://contract.trilliontrust.com/'
                    },


                    hncrpt: {
                        title: "MT电子证据存证平台",
                        text: "铁证网",
                        url: "7",
                        btnName: "立即体验",
                        url1: 'http://www.tiezhengwang.com/'
                    },
                    tiezhengwang: {
                        title: "MT区块链供应链金融平台",
                        text: "湖南省中小企业供应链金融平台",
                        url: "1",
                        btnName: "联系我们",
                        url1: ''
                    },
                    mgr: {
                        title: "MT区块链公共服务平台",
                        text: "长沙高新区区块链公共服务平台",
                        url: "2",
                        btnName: "联系我们",
                        url1: ''
                    },
                    rock: {
                        title: "QuantStone",
                        text: "磐石数字资产量化管理平台",
                        url: "6",
                        btnName: "联系我们",
                        url1: ''
                    },

                },

                routerName: this.$route.name
            }
        },
        created() {

            let routerName = this.$route.name

            if (this.navBannerInfo[routerName]) {
                this.infrastructure = this.navBannerInfo[routerName]
            }
        },
        computed: {
            infrastructure: {
                get() {
                    return this.$store.state.infrastructure.serverInfrastructure
                },
                set(val) {
                    this.$store.commit('infrastructure/updateServerInfrastructure', val)
                }
            },
            isTwo: {
                get() {
                    return this.$route.meta.isTwo
                }
            }
        },

        methods: {
            jump(btnName) {
                let url1 = btnName.url1
                if(url1){
                    window.open(url1, "_blank")
                }else {
                    this.$router.push({name: btnName})
                }
            }
        },
        watch: {
            $route(to, from) {
                this.routerName = to.name

                if (this.navBannerInfo[to.name]) {
                    this.infrastructure = this.navBannerInfo[to.name]
                }
            }
        },
    }
</script>

<style scoped lang="scss">

    .list {
        width: 10%;
        background-color: #fff;
        border: 1px solid rgba(222, 232, 242, 1);
        position: absolute;
        position: -webkit-sticky;
        top: 390px;
        min-width: 250px;
        .item {
            position: relative;
            text-align: center;
            border-bottom: 1px solid #D0DBE6;
            height: 88px;
            line-height: 88px;
            font-size: 18px;
            color: #333333;
            margin: 0 20px;
            cursor: pointer;


            &:last-child {
                border-bottom: 0;
            }

            &:hover{
                color: #61D5FF;
            }
        }

        .active {
            font-size: 18px;
            color: #2A67E3;

            &::before {
                content: "";
                position: absolute;
                width: 12px;
                height: 70px;
                left: -22px;
                bottom: 9px;
                background-color: #61D5FF;
            }
            &:hover {
                color: #61D5FF;

            }
        }

    }
</style>
